import Vue from 'vue';
import _ from 'lodash';

export default {
  namespaced: true,
  state: {
    app: {
      screen: {
        component: 'sta-start-screen',
        modal: '',
        breadcrumbs: [],
      },
      mainMenu: {
        activeTab: 0,
      },
      securityAssessment: {
        activeTab: 0,
      },
      customViewareas: {
        frame0: false,
      },
    },
  },
  mutations: {
    change(state, data) {
      for (const key in data) {
        const obj = _.merge(state.app[key], data[key]);
        Vue.set(state.app, key, obj);
      }
    },
    setBreadcrumbs(state, data) {
      state.app.screen.breadcrumbs = data;
    },
  },
  getters: {
    app: state => {
      return state.app;
    },
  },
  actions: {
    change({ commit }, data) {
      commit('change', data);
    },
    setBreadcrumbs({ commit }, data) {
      commit('setBreadcrumbs', data);
    },
  },
};
